import { render, staticRenderFns } from "./CreateSlides.vue?vue&type=template&id=876eb1aa&scoped=true&"
import script from "./CreateSlides.vue?vue&type=script&lang=js&"
export * from "./CreateSlides.vue?vue&type=script&lang=js&"
import style0 from "./CreateSlides.vue?vue&type=style&index=0&id=876eb1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876eb1aa",
  null
  
)

export default component.exports